module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 14\" enable-background=\"new 0 0 12 14\"><path d=\"m11.5 2.4l-1.3-1.1-1 1.1 1.4 1.1.9-1.1\"/><path d=\"m6.8 2v-.5h.5v-1.5h-2.6v1.5h.5v.5c-2.9.4-5.2 2.9-5.2 6 0 3.3 2.7 6 6 6s6-2.7 6-6c0-3-2.3-5.6-5.2-6m-.8 10.5c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5 4.5 2 4.5 4.5-2 4.5-4.5 4.5\"/><path d=\"m6.2 8.9h-.5c-.1 0-.2-.1-.2-.2v-3.5c0-.1.1-.2.2-.2h.5c.1 0 .2.1.2.2v3.5c0 .1-.1.2-.2.2\"/></svg>\n"


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/app/views/shared/icons/_icon_stopwatch.svg
// module id = 2P/j
// module chunks = 12